import api from './APIService';

class ResultsService {
	getResults(data) {
		return api.fetch({ method: 'post', path: '/participant/results', data });
	}
	getConfigRace($id){
		return api.fetch({ method: 'get', path: '/livelaps/race/config/'+$id });
	}
	getRaceInfo($id){
		return api.fetch({ method: 'get', path: '/livelaps/race/'+$id });
	}
	getResultsUsers(data) {
		return api.fetch({ method: 'post', path: '/participant/results/getResultsUsers', data });
	}
}

export default new ResultsService();
